import api from '../../api/_type'


const state = () => ({
    attributs: [],
    types: [],
    type: [],

})

// getters
const getters = {
    attributs: (state) => {
        return state.attributs
    },
    types: (state) => {
        return state.types
    },
    type: (state) => {
        return state.type
    }
}

// actions
const actions = {

    /**
     * Recuperer la liste des attributs possible pour un champ
     */
    getTypeAttribut({commit}) {
        api.typeAttributs().then(
            data => {
                commit('SET_ATTRIBUTS', data)
            }
        )
    },

    /**
     * Recuperer tout les types d'articles
     * 
     */
    async getTypes({commit}) {
        return api.typeArticles().then(
            response => {

                commit('SET_TYPES', response)
                
                return true
            }
        )
    },

    /**
     * Recuperer un type d'article
     * @param int id 
     */
    async getType({ commit}, id) {
        return api.getType(id).then(
            response => {
                commit('SET_TYPE', response)
                return true
            }
        )
    },

    /**
     * Recuperer les articles d'un type d'article
     * @param int id 
     */
    async getTypeArticles({ commit}, id) {
        
        return api.getTypeArticles(id).then(
            response => {
                commit('SET_TYPES', response)
            }
        )
    },

    /**
     * Enregistrer un type d'article
     * @param object data 
     */
    putTypeArticle({commit, dispatch}, data) {

        return  api.saveTypeArticle(data).then(
            response => {
                if( response.status == 201 ) {
                    commit('SET_TYPE', response.data)
                    dispatch("getTypes")
                    return {"response": true, "id": response.data.id}
                } else {
                    return {"response": false}
                }
            }
        )
        
        
    },

    /**
     * Modifier un type d'article
     * @param int id
     * @param object data 
     */
    editTypeArticle({ dispatch}, {id, data}) {
        return api.editTypeArticle(id, data).then(
            response => {
                if( response.status == 200 ) {
                    dispatch("getTypes")
                    return {"response": true}
                } else {
                    return {"response": false}
                }
            }
        )
    },

    /**
     * Modifier le nom d'un attribut d'un type d'article
     * @param int id 
     * @param object data 
     */
    async editTypeArticleAttribut({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.editTypeArticleAttribut(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    /**
     * Modifier l'attribut d'un type d'article
     * @param int id 
     */
    async deleteTypeArticleAttribut({ dispatch, state}, id) {
        return api.deleteTypeArticleAttribut(id).then(
            response => {

                console.log(response)

                dispatch("getType", state.type.id)

                return true
            }
        )
    },


}

// mutations
const mutations = {
    
    SET_ATTRIBUTS(state,attributs) {
        state.attributs = attributs
    },
    SET_TYPES(state,types) {
        state.types = types
    },
    SET_TYPE(state,type) {
        state.type = type
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}
